<template>
  <uploader-file ref="upfile" :file="file" :list="true">
    <div slot-scope="prop">
      <el-row type="flex">
        <div class="uploader-file-name">{{ prop.file.name }}</div>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="6">{{ prop.formatedSize }}</el-col>
        <el-col :span="12" class="file-info-status">
          <span v-show="prop.status !== 'uploading'">{{ statusText }}</span>
          <span v-show="prop.status === 'uploading' || prop.status === 'pause'">
            <em>{{ prop.formatedAverageSpeed }}</em>
            <i style="padding-left:10px;">{{ prop.formatedTimeRemaining }}</i>
          </span>
        </el-col>
        <el-col :span="6">
          <div class="uploader-file-actions">
            <span class="uploader-file-pause" @click="pause"></span>
            <span class="uploader-file-resume" @click="resume">️</span>
            <span class="uploader-file-retry" @click="retry"></span>
            <span class="uploader-file-remove" @click="remove"></span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-progress
          v-show="prop.status === 'uploading'"
          :percentage="Math.floor(prop.progress * 100)"
        ></el-progress>
      </el-row>
    </div>
  </uploader-file>
</template>
<script>
export default {
  props: {
    file: {
      type: Object,
      default() {
        return {}
      },
    },
    list: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      upfile: {},
    }
  },
  mounted() {
    this.upfile = this.$refs.upfile
  },
  computed: {
    uploader() {
      return this.file.uploader
    },
    status() {
      const isUploading = this.upfile.isUploading
      const isComplete = this.upfile.isComplete
      const isError = this.upfile.error
      const paused = this.upfile.paused
      const md5 = this.file.status
      if (isComplete) {
        return 'success'
      } else if (isError) {
        return 'error'
      } else if (isUploading) {
        return 'uploading'
      } else if (md5) {
        return 'md5'
      } else if (paused) {
        return 'paused'
      } else {
        return 'waiting'
      }
    },
    statusText() {
      const status = this.status
      const fileStatusText = this.uploader.fileStatusText
      let txt = status
      if (typeof fileStatusText === 'function') {
        txt = fileStatusText(status, this.response)
      } else {
        txt = fileStatusText[status]
      }
      return txt || status
    },
  },
  methods: {
    pause() {
      this.upfile.pause()
    },
    resume() {
      this.upfile.resume()
    },
    retry() {
      this.upfile.retry()
    },
    remove() {
      this.upfile.remove()
    },
  },
}
</script>
